import { createSlice } from '@reduxjs/toolkit';

export const layoutSlice = createSlice({
  name: 'layout',
  initialState: {
    isLeftSidebarOpen: true,
    isRightSidebarOpen: true,
  },
  reducers: (create) => ({
    openLeftSidebar: create.reducer((state) => {
      state.isLeftSidebarOpen = true;
    }),
    closeLeftSidebar: create.reducer((state) => {
      state.isLeftSidebarOpen = false;
    }),
    toggleLeftSidebar: create.reducer((state) => {
      state.isLeftSidebarOpen = !state.isLeftSidebarOpen;
    }),
    openRightSidebar: create.reducer((state) => {
      state.isRightSidebarOpen = true;
    }),
    closeRightSidebar: create.reducer((state) => {
      state.isRightSidebarOpen = false;
    }),
    toggleRightSidebar: create.reducer((state) => {
      state.isRightSidebarOpen = !state.isRightSidebarOpen;
    }),
  }),
});

export const {
  actions: layoutActions,
  reducer: layoutReducer,
  selectors: layoutSelectors,
} = layoutSlice;
